export const REQUEST_CREATE_ANNOUNCEMENT = 'announcement/REQUEST_CREATE_ANNOUNCEMENT';
export const REQUEST_DISMISS_ANNOUNCEMENT = 'announcement/REQUEST_DISMISS_ANNOUNCEMENT';
